// extracted by mini-css-extract-plugin
module.exports = {"header":"ShipmentList_header__f3_4J","title":"ShipmentList_title__1eshP","small":"ShipmentList_small__1iK_N","btnContainer":"ShipmentList_btnContainer__1-ZKe"};